import { render, staticRenderFns } from "./applygame.vue?vue&type=template&id=302ffbf7&scoped=true"
import script from "./applygame.vue?vue&type=script&lang=js"
export * from "./applygame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302ffbf7",
  null
  
)

export default component.exports